import React, { Component } from 'react';
import { loginService } from '../../../services/login.service';
import { helperText } from '../../../_helpers/helpertext';
import { isEmailValid, isStringEmpty } from '../../../_helpers/string_helper';
import warning from "../../../Images/warning.png";
import Loader from '../../../_helpers/Loader';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            emailToReset:'',
            isLoading:false,
            resetEmailError: false,
            mailSent: false,
            mailSentError: false,
            isLoading:false,
        };
    }

    
  validateEmail=()=>{
    const{emailToReset}=this.state;
    let hasErrors = false;

    if (isStringEmpty(emailToReset)) {
        hasErrors = true;
        this.setState({
            resetEmailError: helperText.loginPageText.errorEmailAddress,
            mailSent: false,
            mailSentError: false,
        });
    } else if (!isEmailValid(emailToReset)) {
        hasErrors = true;
        this.setState({
            resetEmailError: helperText.loginPageText.inValidEmailAddress,
            mailSent: false,
            mailSentError: false,
        });
    } else
        this.setState({
            resetEmailError: "",
            mailSent: false,
            mailSentError: false,
        });

    if (hasErrors) return;

    this.sendEmail();
  }

   /* <summary>
  date: 24-06-2022
  Name: VD
  description: This is used to send a reset email link to the student who have forgotten their password
  <summary>*/ 
  sendEmail=async()=>{
    this.setState({
      isLoading:true,
    })
    try{
      const{emailToReset}=this.state;
      var response=await loginService.SendResetEmail(emailToReset);
      if(response.status === 200){
        if(response.data === true){
            this.setState({
                mailSent:helperText.loginPageText.mailSentSuccessfully,
            })
        }else{
            this.setState({
                mailSentError:helperText.loginPageText.emailNotRegistered,
            })
        }
      }
    }
    catch(e){
      return "";
    }
    this.setState({
      isLoading:false,
    })
  }

  onTextChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      resetEmailError: false,
    });
  };
    render() {
        const{
            emailToReset,
            resetEmailError,
            mailSent,
            mailSentError,
            isLoading,
        }=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal">
              {isLoading && <Loader />}
              <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                  <div className="modal-body" style={{textAlign: 'center', color: '#444054', padding: '20px'}}>
                    <button type="button" onClick={()=>this.props.clearforgotpassemail()} className="btn-close" style={{float: 'right'}} />
                    <img src={warning} alt="warning" style={{width: '70px', paddingBottom: '10px'}} />
                    <h2 style={{fontSize: '28px'}}>Forgot Password</h2>
                    <h4 style={{padding: '10px 0px', fontWeight: 400, fontSize: '20px'}}>Please enter your registered Primary Email Address</h4>
                    <div style={{display: 'flex', border: '1px solid black', margin: '0px 50px'}}>
                      <i className="fa fa-envelope" style={{padding: '14px 10px 10px 10px', borderRight: '1px solid black'}} />
                      <input 
                        type="email" 
                        className="form-control" 
                        style={{margin:'0px'}}
                        id="emailToReset"
                        name="emailToReset"
                        value={emailToReset}
                        onChange={this.onTextChange} required />
                    </div>
                    {!isStringEmpty(resetEmailError) && (
                                                <small
                                                    id="emailHelp"
                                                    className="form-text"
                                                    style={{ color: "red", marginLeft: "2px" }}
                                                >
                                                    {resetEmailError}
                                                </small>
                                            )}
                    {!isStringEmpty(mailSent) && (
                      <small
                      id="emailHelp"
                      className="form-text"
                      style={{ color: "green", marginLeft: "2px" }}
                      >
                        {mailSent}
                      </small>
                    )}
                    {!isStringEmpty(mailSentError) && (
                      <small
                      id="emailHelp"
                      className="form-text"
                      style={{ color: "red", marginLeft: "2px" }}
                      >
                        {mailSentError}
                      </small>
                    )}
                    <div style={{padding: '20px 0px'}}>
                        <button 
                            type="button" 
                            onClick={()=>this.props.clearforgotpassemail()} 
                            className="btn cancel-btn" 
                            style={{backgroundColor: '#D5CECE', color: 'black', marginRight: '25px'}}
                        >CANCEL</button>

                        <button type="button" 
                            className="question-button btn btn-white"
                            style={{margin:'0px',border:'none'}}
                            onClick={this.validateEmail}
                        >SUBMIT</button>
                    </div>
                    <p>We will reset your Password and send a verification link to your registered Email Address.</p><p>
                    </p></div>
                </div>
              </div>
            </div>
        );
    }
}

export default ForgotPassword;